module.exports = __webpack_public_path__ + "data.2D-HbEy1.png";